import { useGetApiV1SerieSerieidLangsAvailableLanguages } from '@/shared/api/generated';

/**
 * Hook para obter os idiomas ainda não cadastrados para uma Série (alimenta o
 * `SelectInput` de Idioma na tela de criação de Idioma da Série).
 *
 * Envolve o hook gerado pelo Kubb para
 * `GET /api/v1/serie/{serieId}/langs/available-languages`.
 *
 * @param serieId - ID da série
 * @returns `{ options, isLoading }` — `options[].key` é o `cultureInfo` (ex.: `"en-US"`)
 *
 * @example
 * ```tsx
 * const { options } = useAvailableSerieLanguages(serieId);
 * ```
 */
export function useAvailableSerieLanguages(serieId: number) {
  const { data, isLoading } = useGetApiV1SerieSerieidLangsAvailableLanguages(serieId);

  return { options: data ?? [], isLoading } as const;
}
